import React from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  title: {
    //width: '80%',
    height: "20px",
    color: "#787878",
    textAlign: "left",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px !important",
    display: "table",

    "& .MuiTypography-root": {
      fontSize: "14px !important",
    },

    [theme.breakpoints.up("tablet")]: {
      /// display: 'flex',
      width: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      // position: "static",
      // width: '205px',
      // height: '20px',
      // left: '3px',
      // top: '0px'
    },
  },
  firstTitle: {
    fontWeight: "bold",
  },
  circleParentCls: {
    [theme.breakpoints.up("tablet")]: {
      display: "flex",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      // flexDirection: 'row',
      // alignItems: 'flex-start',
      // padding: '0px',
      // width: '108px',
      // height: '12px',
      // left: '208px',
      // top: '4px'
    },
    paddingTop: "3.5px",
  },
  circleChildCls: {
    height: 12,
    width: 12,
    borderRadius: "50%",
    border: "1px solid #C4C4C4",
    margin: "2px 2px",
  },
  sectionWrapper: {
    width: "100%",
    display: "flex",
    marginTop: "10px",
    justifyContent: "space-between",
    // [theme.breakpoints.up("tablet")]: {
    //     display: 'flex'
    // },
    // [theme.breakpoints.down("sm")]: {
    //     width: '319px',
    //     display: 'flex',
    //     flexDirection: 'row',
    //     justifyContent: 'center',
    //     alignItems: 'center'
    // }
  },
  linksty: theme.typography.link2,
}));
const noOfStars = [...Array(7).keys()];

function Sections(props) {
  const classes = useStyles();

  const getColorCode = (dots) => {
    if (dots === 1) {
      return "rgb(221, 46, 46)";
    } else if (dots === 2 || dots === 3 || dots === 4) {
      return "rgb(250, 192, 106)";
    } else if (dots === 5 || dots === 6 || dots === 7) {
      return "rgb(106, 168, 79)";
    } else {
      return "rgb(14, 76, 234)";
    }
  };

  return props?.data?.map((item, index) => {
    return (
      <div className={classes.sectionWrapper}>
        <Typography
          sx={
            index === 0
              ? { fontWeight: "450", marginBottom: "12px", lineHeight: "24px" }
              : {
                  fontWeight: "399",
                  marginBottom: "-4px",
                }
          }
          // component={Text}
          variant2="link2"
          // align="center"
          className={`${classes.title}${classes.linksty}`}
        >
          {/* {item.title || item.fullName} */}
          {item.title === "Required Experience" ? "Years of Experience" : item.title || item.fullName}
        </Typography>
        <div className={classes.circleParentCls}>
          {noOfStars?.map((rec, i) => {
            const color = i <= item.dots - 1 ? getColorCode(item.dots) : "";
            const style = index > 0 && color ? { backgroundColor: color, opacity: 0.8 } : { backgroundColor: color };
            return <div key={i} style={style} className={classes.circleChildCls}></div>;
          })}
        </div>
      </div>
    );
  });
}
export default Sections;
